import PipelineVideo from "../../../../videos/pipeline.mp4";
import ApproveVideo from "../../../../videos/approve-event.mp4";
import ExcludeVideo from "../../../../videos/exclude-machine.mp4";
import * as React from 'react';
export default {
  PipelineVideo,
  ApproveVideo,
  ExcludeVideo,
  React
};